import { createComponent } from "@helpers/admin";
import { YayLogosSectionComponent } from "@template/blocks/LogosSection/component";

export const LogosBanner = createComponent({
  label: "Logos Banner",
  component: YayLogosSectionComponent,
  fields: {
    heading: {
      label: "Heading",
      type: "textarea",
    },
  },
});
